import { startOfDay } from 'date-fns';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@/common/components/Modal';

interface CreateEventModalProps {
  isOpen: boolean;
  selectedDate: Date | null;
  onClose: () => void;
  onSubmit: (event: { title: string; description: string; event_date: Date }) => void;
}

export const CreateEventModal = ({
  isOpen,
  selectedDate,
  onClose,
  onSubmit,
}: CreateEventModalProps) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedDate || !title.trim()) return;

    const event_date = startOfDay(selectedDate);

    onSubmit({
      title: title.trim(),
      description: description.trim(),
      event_date,
    });

    // Reset form
    setTitle('');
    setDescription('');
  };

  const handleClose = () => {
    // Reset form
    setTitle('');
    setDescription('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} title={t('calendarApp.createEvent')} onClose={handleClose}>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('common.title')}
          </label>
          <input
            className="w-full p-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={t('calendarApp.eventTitlePlaceholder')}
            type="text"
            value={title}
            required
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('common.description')}
          </label>
          <textarea
            className="w-full p-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={t('calendarApp.eventDescPlaceholder')}
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-2 pt-4">
          <button
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors"
            type="button"
            onClick={handleClose}
          >
            {t('common.cancel')}
          </button>
          <button
            className="px-4 py-2 text-white bg-gray-900 rounded-xl hover:bg-gray-800 transition-colors"
            disabled={!title.trim()}
            type="submit"
          >
            {t('calendarApp.createEvent')}
          </button>
        </div>
      </form>
    </Modal>
  );
};
